import React, { Component } from 'react'
import { QuoteMark } from '../icons'
import Fade from 'react-reveal/Fade'

class Testimonial extends Component {

  render() {

    const { quote, name, location } = this.props

    return (

      <div className='testimonial'>

        <Fade bottom distance='30px'>

          <div className='testimonial__inner'>

            <div className='testimonial__content'>

              <div className='testimonial__details'>

                <QuoteMark color='#2B2C2F' />

                <div className='testimonial__quote' dangerouslySetInnerHTML={{ __html: quote }} />

                <p className='testimonial__location'>{ name }, {location}</p>

              </div>

            </div>

          </div>

        </Fade>

      </div>
    )
  }
}

export default Testimonial
